import { Reveal, MaskedLines } from "@/components/motion/Reveal";
import { QuoteWizard } from "@/components/QuoteWizard";
import { useSettings } from "@/hooks/useData";

export function QuoteSection({ preset, id = "offerte" }) {
  const s = useSettings();
  return (
    <section id={id} className="bg-white py-28 md:py-40 border-t border-line" aria-labelledby="quote-title">
      <div className="container-x grid lg:grid-cols-12 gap-14 lg:gap-10">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="label text-mute mb-6 flex items-center gap-4"><span className="w-6 h-px bg-ink/40" /> 09 · Offertanfrage</p>
          </Reveal>
          <MaskedLines as="h2" id="quote-title" lines={["In fünf Schritten", "zur Offerte."]} className="display text-4xl sm:text-5xl lg:text-6xl text-ink" />
          <Reveal delay={0.2} className="mt-8">
            <p className="text-sm md:text-base text-mute leading-relaxed max-w-sm">Kostenlos und unverbindlich. Sie erhalten eine klare Offerte, keine Preisliste zum Selberrechnen.</p>
            <div className="mt-10 flex flex-col gap-2 label text-mute">
              <span>Lieber direkt?</span>
              <a href={`tel:${s?.phone_link || ""}`} className="link-line w-max text-ink">{s?.phone}</a>
              <a href={`mailto:${s?.email || ""}`} className="link-line w-max text-ink">{s?.email}</a>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-8 lg:col-start-5 lg:pt-2">
          <QuoteWizard preset={preset} />
        </Reveal>
      </div>
    </section>
  );
}
